module.exports = __webpack_public_path__ + "static/github-white-43dee6d3b49936e0e1e97ffc4a39f8ff.png";